<template>
  <v-dialog
  v-model="dialogEdit"
   max-width="500px"
 >
   <v-card>
     <v-card-title class="title-card">
       <span class="text-h5">{{ formTitle }}</span>
     </v-card-title>

     <v-card-text>
       <v-container>
        <v-form
            ref="form"
            v-model="valid"
          >
          <v-row>
            <v-col
              class="d-flex"
              cols="12"
              sm="12"
              md="12"
            >
              <v-autocomplete
                v-model="obj.empresa.id"
                :items="getEmpresas"
                :item-text="'nome'"
                :item-value="'id'"
                outlined
                label="Empresas"
              ></v-autocomplete>
            </v-col>
            <v-col
              class="d-flex"
              cols="12"
              sm="12"
              md="12"
            >
              <v-select
                v-model="obj.obra.id"
                :items="getObras"
                :rules="nameRules"
                :item-text="'nome'"
                :item-value="'id'"
                outlined
                label="Unidades"
              ></v-select>
            </v-col>
            <v-col
              cols="12"
              sm="12"
              md="12"
            >
              <v-text-field
                v-model="obj.descricao"
                required
                :rules="nameRules"
                label="Descrição"
                outlined
              ></v-text-field>
            </v-col>
            <v-col
              cols="6"
              sm="6"
              md="6"
            >
              <v-text-field
                v-model="obj.nfe"
                required
                :rules="nameRules"
                label="NFE"
                outlined
              ></v-text-field>
            </v-col>
            <v-col
              cols="6"
              sm="6"
              md="6"
            >
              <v-text-field
                v-model="obj.data_vencimento"
                v-mask="'##/##/####'"
                required
                :rules="nameRules"
                label="Data de vencimento"
                outlined
              ></v-text-field>
            </v-col>
            <v-col
              cols="3"
              sm="3"
              md="3"
            >
              <v-text-field
                v-model="obj.valor"
                required
                label="Valor"
                outlined
                type="number"
              ></v-text-field>
            </v-col>
            <v-col
              cols="4"
              sm="4"
              md="4"
            >
            </v-col>
            <v-col
              cols="5"
              sm="5"
              md="5"
              class="mx-0 px-0 d-flex justify-center align-center font-weight-bold pb-6"
            >
              {{ `${obj.parcela}`}}
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="obj.link_google_drive"
                label="Link GOOGLE DRIVE - NOTE"
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="obj.link_google_drive_boleto"
                label="Link GOOGLE DRIVE - BOLETO"
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="obj.link_google_drive_comprovante"
                label="Link GOOGLE DRIVE - COMPROVANTE"
                outlined
              ></v-text-field>
            </v-col>
            
            <v-col cols="12" class="mt-0 pt-0" v-if="obj.link_google_drive">
              <a :href="obj.link_google_drive" target="_blank">Arquivo - GOOGLE DRIVE - NOTA</a>
            </v-col>
            <v-col cols="12" class="mt-0 pt-0" v-else>
              <a :href="obj.link_google_drive" target="_blank" disabled>Documento não cadastrado -  NFE</a>
            </v-col>
            <v-col cols="12" class="mt-0 pt-0" v-if="obj.link_google_drive_boleto">
              <a :href="obj.link_google_drive_boleto" target="_blank">Arquivo - GOOGLE DRIVE - BOLETO</a>
            </v-col>
            <v-col cols="12" class="mt-0 pt-0" v-else>
              <a :href="obj.link_google_drive_boleto" target="_blank" disabled>Documento não cadastrado -  BOLETO</a>
            </v-col>
            <v-col cols="12" class="mt-0 pt-0" v-if="obj.link_google_drive_comprovante">
              <a :href="obj.link_google_drive_comprovante" target="_blank">Arquivo - GOOGLE DRIVE - COMPROVANTE</a>
            </v-col>
            <v-col cols="12" class="mt-0 pt-0" v-else>
              <a :href="obj.link_google_drive_comprovante" target="_blank" disabled>Documento não cadastrado -  COMPROVANTE</a>
            </v-col>
          </v-row>
         </v-form>
       </v-container>
     </v-card-text>

     <v-card-actions class="d-flex justify-space-between">
      <v-row>
        <v-col cols="6">
          <v-btn
            dark
            color="green"
            @click="pagar"
          >
            Pagar
          </v-btn>
        </v-col>
        <v-col cols="6">
          <v-btn
            color="primary"
            text
            @click="closeEditItem"
          >
            Cancelar
          </v-btn>
          <v-btn
            dark
            color="primary"
            @click="save"
          >
            Salvar
          </v-btn>
        </v-col>
      </v-row>
     </v-card-actions>
   </v-card>
 </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
export default {
  /* eslint-disable */
 props:{
    dialogEdit: Boolean,
    objValue: Object,
   },
  data () {
    return {
      valid:false,
      formTitle:'Editar',
      nameRules: [
          v => !!v || 'Campo requirido',
      ],
      dialog: false,
      obj: {
      descricao: '',
      nome:'',
      data_vencimento:'',
      },
    }
   },
   async created () {
    await this.getAllEmpresas();
    this.obj = this.objValue
  },
  /* eslint-disable */
  watch: {
    objValue(){
      this.obj = this.objValue
    }
  },
   methods: {
    ...mapActions('boleto', ['updateBoleto']),
    ...mapActions('empresa', {getAllEmpresas:'getAllEmpresas'}),
    ...mapActions('saida', ['saveSaida']),
    save() {
    this.$refs.form.validate()
      /* eslint-disable no-console */
      if (this.valid) {
        const data_vencimento = this.parseDateFromDDMMYYYY(this.obj.data_vencimento);
        const data_vencimento_timestamp = data_vencimento.getTime();
        this.updateBoleto({
          ...this.obj,
          data_vencimento: this.formatDateToDDMMYYYY(data_vencimento),
          data_vencimento_timestamp,
          data_saida: this.formatDateToDDMMYYYY(data_vencimento)
        });
        this.$emit('searchByFilter');
        this.$emit('closeEditItem');
      }
    },
    formatDateToDDMMYYYY(date) {
      const day = String(date.getDate()).padStart(2, '0'); // Ensure day is always 2 digits
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed (0 = January)
      const year = date.getFullYear();

      return `${day}/${month}/${year}`;
    },
    parseDateFromDDMMYYYY(dateString) {
      const [day, month, year] = dateString.split('/').map(Number);
      return new Date(year, month - 1, day); // Months are zero-indexed
    },
    async pagar() {
      if (this.valid) {
        const data_vencimento = this.parseDateFromDDMMYYYY(this.obj.data_vencimento);
        const data_vencimento_timestamp = data_vencimento.getTime();
        await this.updateBoleto({
          ...this.obj,
          data_vencimento: this.formatDateToDDMMYYYY(data_vencimento),
          data_vencimento_timestamp,
          data_saida: this.formatDateToDDMMYYYY(data_vencimento),
          isPago: true
        });
        let objSaida = {...this.obj};
        delete objSaida.id;
        await this.saveSaida({...objSaida, 
          data_vencimento: this.formatDateToDDMMYYYY(data_vencimento),
          data_vencimento_timestamp,
          data_saida: this.formatDateToDDMMYYYY(data_vencimento),
          active: true, isPago: true});
        this.$emit('searchByFilter');
        this.$emit('closeEditItem');
      }
    },
    reset () {
      this.$refs.form.reset()
    },
    closeEditItem () {
      this.$emit('closeEditItem')
    }  
 },
  computed: {
    ...mapGetters('pessoa',['getList']),
    ...mapGetters('obra', {getObras:'getList'}),
    ...mapGetters('empresa', {getEmpresas:'getList'}),
    customObj(){
      return {
        ...this.obj,
        data_vencimento_timestamp: this.formatToDatastamp(this.obj.data_vencimento)
      }
    }
  },
}
</script>
